import { useMsal } from '@azure/msal-react';
import { Avatar, Button, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { IUser } from '../../contracts/user.contract';
import { UserFetch } from '../../features/user.feature';
import LogoutIcon from './log-out-icon.png';
import UserInfoIcon from './user-icon.png';

const HeaderUserInfo = () => {
    const { instance } = useMsal();

    const dispatch = useAppDispatch();
    const currentUser = useAppSelector((state) => state.User.CurrentUser);
    const [isImpersonated, setIsImpersonated] = useState<boolean>(false);

    useEffect(() => {
        if (!currentUser) dispatch(UserFetch.GetCurrentUser());

        const user = sessionStorage.getItem('impersonatedUser');
        if (!user) return;
        setIsImpersonated(true);
    }, [currentUser, dispatch]);

    const handleLogout = () => {
        instance.logoutRedirect();
    };

    return (
        <Stack spacing={0} direction="row" alignItems="center" justifyContent="flex-end" sx={{ backgroundColor: '#002A4D', height: '100%', paddingRight: '10px' }}>
            {currentUser && (
                <Button
                    variant="contained"
                    size="small"
                    startIcon={<Avatar src={UserInfoIcon} sx={{ height: '26px', width: '26px' }} />}
                    sx={{ textTransform: 'none', fontWeight: 'bold', boxShadow: 'none' }}
                >
                    {`${isImpersonated ? currentUser.Email : currentUser.UserName}`}
                </Button>
            )}

            <Button
                variant="contained"
                onClick={handleLogout}
                size="small"
                startIcon={<Avatar src={LogoutIcon} sx={{ height: '26px', width: '26px' }} />}
                sx={{ textTransform: 'none', fontWeight: 'bold', boxShadow: 'none' }}
            >
                Logout
            </Button>
        </Stack>
    );
};

export default HeaderUserInfo;
